import { t } from "i18next";
import React from "react";
import { CheckCircleIcon, HouseIcon } from "../assets/icons";
import { ListItemSkeleton } from "./SkeletonComponents";
import { useSelector } from "react-redux";
import SecureImage from "./SecureImage";
import clsx from "clsx";

const ValuationList = ({ handleSelect }) => {
  const { valuations, currentValuation, valuationsLoading } = useSelector(
    (state) => state.valuationsDetails
  );

  const valuationItem = (valuation) => (
    <div
      className="flex justify-between gap-4 items-center bg-accumin-neutral-100 my-2 rounded-xl p-2 cursor-pointer"
      key={`${valuation}-${valuation?.id}`}
      onClick={() => handleSelect(valuation)}
    >
      {valuation?.image ? (
        <SecureImage src={valuation?.image}>
          {(imageSrc) => (
            <img
              className={clsx(
                "w-12 h-12 rounded-xl m-1 shrink-0 object-cover"
                // valuation?.replaced_reports !== null &&
                //   valuation?.id_replaced_reports !== null
                //   ? "opacity-25"
                //   : ""
              )}
              src={imageSrc || "/images/placeholder.png"}
              alt="valuation-img"
            />
          )}
        </SecureImage>
      ) : (
        <div className="bg-white rounded-2xl p-1 m-1 w-12 h-12 flex justify-center">
          <HouseIcon className="primary-300-svg self-center" />
        </div>
      )}
      <div>
        <div className="text-base text-accumin-neutral-500">
          {valuation?.street + ", " + valuation?.streetNumber}
        </div>
        <div className="text-sm text-accumin-neutral-400">
          {valuation?.zip + " " + valuation?.city}
        </div>
      </div>
      <div className="ml-auto">
        {currentValuation === valuation.id ? (
          <CheckCircleIcon className="fill-accumin-primary-electric-blue w-6 h-6" />
        ) : (
          ""
        )}
      </div>
    </div>
  );

  return (
    <>
      <div className="page-title mb-4">{t("valuations.title")}</div>
      <div className="overflow-y-auto">
        {valuationsLoading ? (
          Array(3)
            .fill(1)
            .map((_, index) => <ListItemSkeleton key={index} />)
        ) : (
          <div>
            {valuations &&
              Object.values(valuations)
                .filter((valuation) => !!valuation.basicValuation)
                .map((valuation) => valuationItem(valuation.basicValuation))}
          </div>
        )}
      </div>
    </>
  );
};

export default ValuationList;
